import PropTypes from 'prop-types';

/** @jsx jsx */
import { css, jsx } from '@emotion/core';

const StaticField = ({ label, bold, variant }) => (
  <span
    css={css`
      ${variant && variant === 'number' ? 'float: right;' : ''}
      font-weight: ${bold ? '600' : 'inherit'};
    `}
  >
    {label}
  </span>
);

StaticField.displayName = 'staticField';
StaticField.propTypes = {
  label: PropTypes.string.isRequired,
  /**
   * Used for styling.
   */
  variant: PropTypes.oneOf(['number']),
  bold: PropTypes.bool
};

StaticField.defaultProps = {
  variant: null,
  bold: false
};

export default StaticField;
